/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import Link from 'next/link';
import CorpActionTag from './CorpActionTag';
import { BarWrapper, IconArrow } from './styled';

interface CorpActionBarProps {
  symbol: string;
  corpAction: Record<string, any>;
  isGuestCompanyStock?: boolean;
  onClick?: (...args) => void;
}

function CorpActionBar({
  symbol,
  corpAction,
  isGuestCompanyStock = false,
  onClick,
}: CorpActionBarProps) {
  const onClickLink = (event) => (isGuestCompanyStock ? onClick(event) : false);
  return (
    <Link href={`/symbol/${symbol}/corpaction`} passHref onClick={onClickLink}>
      <a>
        <BarWrapper>
          <Flex align="center">
            <CorpActionTag corpAction={corpAction} />
            {/* @ts-expect-error */}
            <Text
              as="span"
              color={color.highempahis}
              weight="600"
              ml="8px"
              size="12px"
            >
              Perusahaan memiliki Corporate Action
            </Text>
          </Flex>
          <IconArrow as="span" />
        </BarWrapper>
      </a>
    </Link>
  );
}

export default CorpActionBar;
